import type { InterventionEntity } from "@/entities/intervention";

export const getInterventionsTotalCost = (
  interventions: InterventionEntity[] = []
): number => {
  return interventions.reduce((total, { cost }) => total + (cost ?? 0), 0);
};
